package io.horion.auth.presentation.ui.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.presentation.ui.components.auth.VerificationBanner
import io.horion.auth.presentation.ui.theme.AuthTheme
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.vh
class PageLayoutData(val title: String)

@Composable
@Layout
fun PageLayout(ctx: PageContext, content: @Composable ColumnScope.() -> Unit) {
    val data = ctx.data.getValue<PageLayoutData>()
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)

    val isProfilePage = window.location.pathname.startsWith("/profile")

    LaunchedEffect(data.title) {
        document.title = "Orion-${data.title}"
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(100.vh)
            .backgroundColor(colors.background)
            .fontFamily("Inter")
            .gridTemplateRows { size(minContent); size(minContent); size(1.fr) }
    ) {
        if (!isProfilePage) {
            TopBar()
            VerificationBanner()
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .gridRow(if (isProfilePage) 1 else 3),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(
                modifier = Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally,
                content = content
            )
        }
    }
}